import { Component, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject, concat, of } from 'rxjs';
import { takeUntil, startWith, filter, debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';

@Component({
  selector: 'eos-ad-typeahead-with-displayText',
  template: `
  <ng-select [items]="options$ | async"
    bindLabel="userPrincipalName"
    [minTermLength]="3"
    typeToSearchText="Please enter 3 or more characters"
    [loading] = "showLoader"
    [placeholder]="to.placeholder"
    [typeahead]="searchInput$"
    [formControl]="formControl">
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div><span>{{item.userPrincipalName}}</span></div>
      <div><span><small>{{item.displayName}}</small></span></div>
    </ng-template>
  </ng-select>
  `,
})

export class TypeaheadTypeComponentWithDisplayText extends FieldType implements OnDestroy {
  onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  options$;
  showLoader = false;

  constructor(private ad: ActiveDirectoryService) {
    super();
  }

  ngOnInit() {
    this.options$ = concat(
      of([]),
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter(v => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.showLoader = true),
        switchMap(term => this.ad.getAdUsers(term).pipe(
          catchError(() => of([])),
          tap(() => this.showLoader = false)
        ))
      )
    );
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}